import { motion } from "framer-motion";
import { WhatsAppButton, PreventivoButton, EmailButton } from "./CTAs";
import { neutralizeWA } from "../../config";

export default function FinalCTA() {
  return (
    <section className="relative bg-navy text-white py-20 sm:py-28 overflow-hidden">
      <div className="noise-overlay" />
      <div className="pointer-events-none absolute left-1/2 -translate-x-1/2 -top-24 h-72 w-[600px] rounded-full bg-brand-orange/20 blur-3xl" />
      <div className="relative mx-auto max-w-3xl px-4 sm:px-6 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl leading-[1.02]"
        >
          Pronto a iniziare il tuo lavoro?
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-5 text-white/75 text-lg"
        >
          {neutralizeWA("Scrivici ora su WhatsApp o richiedi un preventivo gratuito. Ti rispondiamo in fretta.")}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-9 flex flex-col sm:flex-row justify-center gap-3"
        >
          <WhatsAppButton size="lg" testid="final-whatsapp" label="Preventivo su WhatsApp" />
          <PreventivoButton size="lg" variant="orange" testid="final-preventivo" label="Preventivo Online" />
          <EmailButton size="lg" variant="outlineLight" testid="final-email" label="Via Email" />
        </motion.div>
      </div>
    </section>
  );
}
